<template>
  <div class="addHospital pb-4">
    <h3 class="pb-3 px-1 mb-0"></h3>
    <ValidationObserver ref="addHospital" v-slot="{ handleSubmit }">
      <form id="addHospital" @submit.prevent="handleSubmit(onSubmit)">
        <CCardGroup class="has-loading-overlay">
          <CCard class="p-2">
            <CCardBody>
              <CRow class="row mb-3">
                <label class="required col-lg-3 col-md-12">Hospital Name</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <ValidationProvider
                    :rules="{ required: true, hospital_name: 100 }"
                    v-slot="{errors}"
                  >
                    <TextInput
                      name="hospital_name"
                      :value="hospitals.hospital_name"
                      @input="handleInput"
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="required col-lg-3 col-md-12">Website</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <TextInput
                      name="website"
                      :value="hospitals.website"
                      @input="handleInput"
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="required col-lg-3 col-md-12">Email</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <ValidationProvider rules="required|email" v-slot="{errors}">
                    <TextInput
                      name="email"
                      :value="hospitals.email"
                      @input="handleInput"
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="col-lg-3 col-md-12">Address</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <TextInput
                    name="addres"
                    :value="hospitals.address"
                    @input="handleInput"
                  />
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="required col-lg-3 col-md-12">Location</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <Select
                      name="location_id"
                      :value="hospitals.location_id"
                      @input="handleChangeSelect"
                      :options="options && options['locations'] ? options['locations'] : []"
                      :taggable="false"
                      :multiple="false"
                      :clearable="true"
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="required col-lg-3 col-md-12">No. of Beds</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <ValidationProvider rules="required" v-slot="{errors}">
                    <TextInput
                      name="no_of_beds"
                      type="number"
                      :value="hospitals.no_of_beds"
                      @input="handleInput"
                      :error="errors[0]"
                    />
                  </ValidationProvider>
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="col-lg-3 col-md-12">Government</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <RadioButton
                    name="government"
                    :value="hospitals.government"
                    :options="options && options['government'] ? options['government'] : []"
                    @change="handleChangeRadio"
                  />
                </div>
              </CRow>
              <CRow class="row mb-3">
                <label class="col-lg-3 col-md-12">Private</label>
                <div class="col-lg-4 col-md-6 col-sm-12">
                  <RadioButton
                    name="private"
                    :value="hospitals.private"
                    :options="options && options['private'] ? options['private'] : []"
                    @change="handleChangeRadio"
                  />
                </div>
              </CRow>
            </CCardBody>
          </CCard>
        </CCardGroup>
        <div class="text-center mx-0 mt-4 pt-4 pb-4" style="padding-bottom:150px!important">
          <button class="btn rounded-0 px-5 btn-primary btn-lg" type="submit">Submit</button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Vue from "vue";
import m from "moment";
import { times } from "lodash";
import { extend } from "vee-validate";
import { required, email, confirmed, min, max } from "vee-validate/dist/rules";
import { mapGetters, mapActions } from "vuex";

extend("required", { ...required, message: "This field is required" });
extend("hospital_name", { ...max, message: "Max length: 100 character" });
extend("email", { ...email, message: "Invalid email" });

import Select from "@/components/reusable/Fields/Select.vue";
import TextInput from "@/components/reusable/Fields/TextInput";
import PhoneInput from "@/components/reusable/Fields/PhoneInput";
import RadioButton from "@/components/reusable/Fields/RadioButton";
import DateInput from "@/components/reusable/Fields/DateInput";
export default {
  components: {
    Select,
    TextInput,
    DateInput,
    RadioButton,
    PhoneInput
  },
  computed: {
    ...mapGetters(["locations"]),
    options() {
      return {
        locations: this.locations || [],
        government: [
          { id: true, label: "Yes" },
          { id: false, label: "No" }
        ],
        private: [
          { id: true, label: "Yes" },
          { id: false, label: "No" }
        ]
      };
    }
  },
  data() {
    return {
      isFileError: false,
      hospitals: {},
      payload: {}
    };
  },
  mounted() {
    this.initAddHospitalFetchOptions();
  },
  methods: {
    ...mapActions(["initAddHospitalFetchOptions", "showToast"]),
    handleInput(name, value) {
      Vue.set(this.hospitals, name, value);
      Vue.set(this.payload, name, value);
    },
    handleChangeRadio(name, value) {
      let val = null;
      if (value.id === false || value.code === false) {
        val = false;
      } else {
        val = value.id || value.code || value;
      }
      Vue.set(this.hospitals, name, value);
      this.payload = {
        ...this.payload,
        [name]: val
      };
    },
    handleChangeSelect(name, value) {
      Vue.set(this.hospitals, name, value);
      this.payload = {
        ...this.payload,
        [name]: value ? value.id || value.code || value : null
      };
    },
    async onSubmit() {
      const isValid = await this.$refs.addHospital.validate();
      if (!isValid) {
        this.showToast({
          class: "bg-danger text-white",
          message: "please fill mandatory fields!"
        });
        return;
      }
      this.$emit("submit", this.payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.hint {
  opacity: 0.7;
}
</style>

